module.exports = __webpack_public_path__ + "media/images/admin/icons/chevron-left-982a40d4f9e3cf9fdaeaf4af9da46c14.svg";